import { defineComponent as _defineComponent } from 'vue'
import {
  ButtonContainer,
  ButtonPrimary,
  HelperViewContextual,
  HelperViewStatus,
  Modal
} from '@warrenbrasil/nebraska-web';
import { Portal } from '@/modules/common/components/Portal';
import { Ref, computed, inject, ref } from 'vue';
import {
  IRecaptcha,
  Recaptcha,
  RecaptchaActions
} from '@/modules/authentication/components/Recaptcha';
import { NotificationTypes } from '@/modules/wallet-builder/src/types';
import { notify } from '@/modules/common/helpers/notification';
import { resetPassword } from '@/modules/common/services/http/account';
import {
  ForgotPasswordModalSteps,
  SignInForm
} from '@/modules/authentication/views/SignIn/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordModal',
  props: {
  isOpen: { type: Boolean, default: false }
},
  emits: ['close', 'submit'],
  setup(__props, { emit }) {

const step = ref<ForgotPasswordModalSteps>(ForgotPasswordModalSteps.Input);
const recaptchaToken = ref<string>('');
const recaptcha = ref<IRecaptcha | null>(null);
const form = inject('form') as Ref<SignInForm>;
const isLoading = ref<boolean>(false);




const buttonLabel = computed(() => {
  return step.value === ForgotPasswordModalSteps.Input
    ? 'Redefinir senha'
    : 'Ir para o Login';
});

function handleButtonClick() {
  if (step.value === ForgotPasswordModalSteps.Input) {
    handleRecaptcha();
  } else {
    emit('close');
    setTimeout(() => {
      step.value = ForgotPasswordModalSteps.Input;
    }, 500);
  }
}

async function submit() {
  isLoading.value = true;
  try {
    await resetPassword({
      email: form.value.email,
      token: recaptchaToken.value
    });
    step.value = ForgotPasswordModalSteps.Success;
  } catch (err) {
    notify({
      group: 'wrn-notifications',
      text: 'Ocorreu um erro ao enviar o e-mail. Por favor, tente novamente.',
      type: NotificationTypes.error
    });
  } finally {
    isLoading.value = false;
  }
}

async function handleRecaptcha() {
  isLoading.value = true;
  const recaptchaEl = recaptcha.value as unknown as IRecaptcha;

  try {
    await recaptchaEl.onChallenge(RecaptchaActions.RESET_PASSWORD);
  } catch {
    notify({
      group: 'wrn-notifications',
      text: 'Ocorreu um erro ao continuar, verifique sua internet e tente novamente.',
      type: NotificationTypes.error
    });
    isLoading.value = false;
  }
}

async function onRecaptchaToken(token: string) {
  recaptchaToken.value = token;
  recaptchaToken.value && (await submit());
}

return { __sfc: true,step, recaptchaToken, recaptcha, form, isLoading, emit, buttonLabel, handleButtonClick, submit, handleRecaptcha, onRecaptchaToken, ButtonContainer, ButtonPrimary, HelperViewContextual, HelperViewStatus, Modal, Portal, Recaptcha, ForgotPasswordModalSteps }
}

})